import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Route, Redirect, Switch} from 'react-router-dom'
import Patient from '../pages/Patient'
import testDbqs from '../pages/testDbqs'
import TestScript from '../pages/testScript'
// import List from '../pages/dbqList'
import CorrectedDbq from '../pages/CorrectedDbq'
import Rect from '../pages/Rect-Python'
import DisabilityConfirm from '../pages/DisabilityConfirm'
import Exam from '../pages/Exam'
// import Scars from '../pages/Scars'
import Review from '../pages/Review'
import DBQ from '../pages/Dbq'
import Sign from '../pages/Sign'
import CorrectSign from '../pages/CorrectSign'
import Note from '../pages/NoteRejected'
import Home from '../pages/Home'
import ViewCorrected from '../pages/viewCorrected'

// import Header from '../components/Header'
import SidebarContainer from '../components/Sidebar'
import {Grid, Row, Col, MainContainer} from '@sketchpixy/rubix'
import Profile from '../pages/Profile'
import AdminProfile from '../pages/AdminProfile'
import {APP_ADMIN_ROLE, ADMIN_ROLE} from '../utils'
import { ConfirmDoctorLicense } from '../pages/ConfirmDoctorLicense'

class AdminRouter extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  refreshRoute = () => {
    const {refreshFlag = false} = this.state
    this.setState({
      refreshFlag: !refreshFlag
    })
  }

  RenderRoute = ({component: Component, ...rest}) => {
    console.log(rest.allowedUsers)
    const loginRole = localStorage.getItem("role")
    let flag = false;
    if(rest.allowedUsers && rest.allowedUsers.length ) {
      flag = rest.allowedUsers.includes(loginRole)
    }
    return flag ? (
      rest.path === "/admin/exam" && !sessionStorage.getItem("currentDbq") ? (
        <Redirect to="/admin/dashboard" />
      ) : (
        <Route
          {...rest}
          component={(props) => <Component {...rest} {...props} />}
        />
      )
    ) : null;
  }

  render() {
    const {refreshFlag} = this.state;
    const {history} = this.props;
    const RenderRoute = this.RenderRoute;

    return (
      <MainContainer location={history.location}>
        <SidebarContainer {...this.props} refreshRoute={refreshFlag} routeChange={this.refreshRoute}/>
        {/* <Header {...this.props}/> */}
        <div id='body' style={{borderRadius: '10px !important'}}>
          <Grid>
            <Row>
              <Col xs={12}>
                <Switch>
                  <RenderRoute exact path='/admin/dashboard' component={Home}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}
                         routeChange={this.refreshRoute}/>
                  <RenderRoute exact path='/admin/confirmPatient' component={Patient}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/confirmDisability' component={DisabilityConfirm}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/exam' component={Exam} 
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/corrected' component={ViewCorrected}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  {/* <RenderRoute exact path='/admin/signLater' component={SignLater}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/> */}
                  <RenderRoute exact path='/admin/review' component={Review}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/confirm-license' component={ConfirmDoctorLicense}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/dbq' component={DBQ}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/> 
                  {/* <RenderRoute exact path='/admin/list' component={List}
                         history={history} allowedUsers={[APP_ADMIN_ROLE]}/>                     */}

                  <RenderRoute exact path='/admin/sign' component={Sign}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/signAgain' component={CorrectSign}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>                  
                  <RenderRoute exact path='/admin/compatibility' component={testDbqs}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/script' component={TestScript}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/compare' component={CorrectedDbq}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/note' component={Note}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/profile' component={Profile}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/profile/:id' component={AdminProfile}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  <RenderRoute exact path='/admin/rect' component={Rect}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>
                  {/* <RenderRoute exact path='/admin/e-sign' component={ESign}
                         history={history} allowedUsers={[APP_ADMIN_ROLE, ADMIN_ROLE]}/>   */}             

                  <Redirect to='/admin/dashboard'/>
                </Switch>
              </Col>
            </Row>
          </Grid>
        </div>
      </MainContainer>
    )
  }
}

const mapStateToProps = ({login}) => {
  const {loginToken, role} = login
  return {loginToken, role}
}

export default connect(mapStateToProps, null)(AdminRouter)
